import {
	pushNextStepEvent,
	pushStartDecisionToolEvent,
	pushViewResultEvent,
} from '@/globals/analytics/events/pushDecisionToolEvent';
import { convertGivenAnswersToSearchParams } from '../_data/useGivenAnswers';
import { AnyRenderedQuestion, GivenAnswers } from './question.types';

export const pushDecisionToolSubmitEvents = ({
	answerTitle,
	answeredQuestionsLength,
	hasStartedDecisionTool,
	hasViewedResult,
	isCompletingDecisionTool,
	nextGivenAnswers,
	onDecisionToolStarted,
	onResultViewed,
	question,
	questions,
}: {
	answerTitle: string | undefined;
	answeredQuestionsLength: number;
	hasStartedDecisionTool: boolean;
	hasViewedResult: boolean;
	isCompletingDecisionTool: boolean;
	nextGivenAnswers: GivenAnswers;
	onDecisionToolStarted: () => void;
	onResultViewed: () => void;
	question: AnyRenderedQuestion;
	questions: Array<AnyRenderedQuestion>;
}) => {
	const isFirstAnsweredQuestion = answeredQuestionsLength === 0;

	if (isFirstAnsweredQuestion) {
		if (!hasStartedDecisionTool) {
			pushStartDecisionToolEvent();
		}
		onDecisionToolStarted();
	}

	pushNextStepEvent({
		answerTitle,
		questionId: question.id,
		questionTitle: question.titleText,
	});

	if (!isCompletingDecisionTool) {
		return;
	}

	const hasInitialResultView =
		(hasStartedDecisionTool || isFirstAnsweredQuestion) && !hasViewedResult;

	pushViewResultEvent({
		action: hasInitialResultView ? 'view_result' : 'view_result_midflow',
		givenAnswersSearchParamsString: convertGivenAnswersToSearchParams(
			nextGivenAnswers,
			questions,
		).toString(),
	});
	onResultViewed();
};
